export default [
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhapp.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhapp.jpg',
    officialId: 'hkguruclub',
    'zh-cn': {
      title: '格隆汇APP',
      desc: '中国领先的全球投资研究平台。全球视野，下注中国。让普通的投资者能够享受到专业的研究服务，让每一个个体的投资之路不再孤单和艰难。',
    },
    'zh-hk': {
      title: '格隆匯APP',
      desc: '中國領先的全球投資研究平臺。全球視野，下注中國。讓普通的投資者能够享受到專業的研究服務，讓每一個個體的投資之路不再孤單和艱難。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/gelong.jfif',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/gelong.png',
    officialId: 'guru-lama',
    'zh-cn': {
      title: '格隆',
      desc: '一个游走于资本市场与佛祖之间的浪子。我可以生，可以死，我大笑，由天决定！',
    },
    'zh-hk': {
      title: '格隆',
      desc: '一個遊走於資本市場與佛祖之間的浪子。我可以生，可以死，我大笑，由天决定！',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhcjrd.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhcjrd.jpg',
    officialId: 'glh_finance',
    'zh-cn': {
      title: '格隆汇财经热点',
      desc: '国际国内财经大事小情，我们有幽默风趣又不失专业的分析与解读！第一时间，一网打尽！',
    },
    'zh-hk': {
      title: '格隆匯財經熱點',
      desc: '國際國內財經大事小情，我們有幽默風趣又不失專業的分析與解讀！第一時間，一網打盡！',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhtlq.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhtlq.jpg',
    officialId: 'glh-tlq',
    'zh-cn': {
      title: '格隆汇探雷区',
      desc: '股市避雷针，选股探一探，牢记安全第一！',
    },
    'zh-hk': {
      title: '格隆匯探雷區',
      desc: '股市避雷針，選股探一探，牢記安全第一！',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhyj.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhyj.jpg',
    officialId: 'glh_tushuocaijing',
    'zh-cn': {
      title: '格隆汇研究',
      desc: '格隆汇研究院旗下公众号，打造数据驱动型研究院，专注行业和个股深度分析，深度挖掘投资机会，提示投资风险。',
    },
    'zh-hk': {
      title: '格隆匯研究',
      desc: '格隆匯研究院旗下公眾號，打造數據驅動型研究院，專注行業和個股深度分析，深度挖掘投資機會，提示投資風險。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhnewstock.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhnewstock.jpg',
    officialId: 'ipopress',
    'zh-cn': {
      title: '格隆汇新股',
      desc: '为您提供全球市场深度、全面的IPO解读',
    },
    'zh-hk': {
      title: '格隆匯新股',
      desc: '為您提供全球市場深度、全面的IPO解讀',
    },
  },
  {
    icon: 'https://glhcdn.oss-cn-hangzhou.aliyuncs.com/static/web/official-accounts/icon/etf.jpeg',
    qrcode:
      'https://glhcdn.oss-cn-hangzhou.aliyuncs.com/static/web/official-accounts/qrcode/etf-qrcode.jpeg',
    officialId: 'gh_256f08854842',
    'zh-cn': {
      title: 'ETF进化论',
      desc: '聚焦全球ETF市场，和专业投资者一起复利奔跑！',
    },
    'zh-hk': {
      title: 'ETF進化論',
      desc: '聚焦全球ETF市場，和專業投資者一起復利奔跑！',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhtjtx.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhtjtx.jpg',
    officialId: 'glh-views',
    'zh-cn': {
      title: '格隆汇图解天下',
      desc: '有图有真相，聚焦全球财经动态，专业的投资者都在看。',
    },
    'zh-hk': {
      title: '格隆匯圖解天下',
      desc: '有圖有真相，聚焦全球財經動態，專業的投資者都在看。',
    },
  },

  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhcjzc.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhcjzc.jpg',
    officialId: 'GuruClubMaker',
    'zh-cn': {
      title: '格隆汇财经早餐',
      desc: '专业、迅速、全面、权威，三分钟掌握全球热点资讯，把握每时每刻投资机会。',
    },
    'zh-hk': {
      title: '格隆匯財經早餐',
      desc: '專業、迅速、全面、權威，三分鐘掌握全球熱點資訊，把握每時每刻投資機會。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhls.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhls.jpg',
    officialId: 'glh_fang',
    'zh-cn': {
      title: '格隆汇楼市',
      desc: '有趣，有料，有深度，格隆汇专业投研团队倾力打造的大湾区楼市公号。',
    },
    'zh-hk': {
      title: '格隆匯樓市',
      desc: '有趣，有料，有深度，格隆匯專業投研團隊傾力打造的大灣區樓市公號。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glsxy.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glsxy.jpg',
    officialId: 'gh_45266ada1a93',
    'zh-cn': {
      title: '格隆商学院',
      desc: '学理财，上格隆商学院——专业师资课件助力普通人的投资成长。',
    },
    'zh-hk': {
      title: '格隆商學院',
      desc: '學理財，上格隆商學院——專業師資課件助力普通人的投資成長。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/ggdsj.jpg',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/gougudata.jpg',
    officialId: 'gh_151be6f174a1',
    'zh-cn': {
      title: '勾股大数据',
      desc: '全方面覆盖国内外宏观经济动态及上市公司，为投资者的超额收益赋能。',
    },
    'zh-hk': {
      title: '勾股大數據',
      desc: '全方面覆蓋國內外總體經濟動態及上市公司，為投資者的超額收益賦能。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhclub.jfif',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhclub.jpg',
    officialId: 'hkgelonghui',
    'zh-cn': {
      title: '格隆汇CLUB',
      desc: '中国领先的全球投资研究平台。 全球视野，下注中国。',
    },
    'zh-hk': {
      title: '格隆匯CLUB',
      desc: '中國領先的全球投資研究平臺。全球視野，下注中國。',
    },
  },
  {
    icon: 'https://cdn.gelonghui.com/static/web/official-accounts/icon/glhqnp.jfif',
    qrcode:
      'https://cdn.gelonghui.com/static/web/official-accounts/qrcode/glhqnp.jpg',
    officialId: 'guruclub_hrs',
    'zh-cn': {
      title: '格隆汇圈内聘',
      desc: '专注上市公司圈与投资圈人才精准招聘。格隆汇作为国内领先的投研平台，目前已与3000+上市公司、5000+金融机构，以及10000+金融圈人才建立点对点联系。',
    },
    'zh-hk': {
      title: '格隆匯圈內聘',
      desc: '專注上市公司圈與投資圈人才精准招聘。格隆匯作為國內領先的投研平臺，現時已與3000+上市公司、5000+金融機構，以及10000+金融圈人才建立點對點聯系。',
    },
  },
];
